function isLocalBook(book) {
  return typeof book?.id === 'string' && book.id.includes('/local_books/')
}

function applyRouteOptions(route, options = {}) {
  const query = { ...(options.query || {}) }
  if (options.fromEmail) query.fromEmail = options.fromEmail
  if (Object.keys(query).length > 0) route.query = query
  if (options.hash) route.hash = options.hash
  return route
}

/**
 * Build a Vue Router location for a book detail page.
 * Uses the backend slug when available; falls back to the IRI-based route
 * when slug is absent to avoid synthesized slugs that may not match the backend.
 * @param {{ id: string, slug?: string }} book
 * @param {{ fromEmail?: string, query?: object, hash?: string }} options
 * @returns {string|object} Vue Router location
 */
export function buildBookUrl(book, options = {}) {
  if (!book) return '/book/'

  if (book.slug) {
    const path = isLocalBook(book) ? `/local-book/${book.slug}` : `/book/${book.slug}`
    return applyRouteOptions({ path }, options)
  }

  // No backend slug — use IRI-based route to avoid a synthesized slug
  // that may not match the persisted value on the bookBySlug resolver.
  if (!book.id) return '/book/'
  return applyRouteOptions({ name: 'book', params: { id: book.id } }, options)
}
